import { render, staticRenderFns } from "./wxprice.vue?vue&type=template&id=87da6980&scoped=true&"
import script from "./wxprice.vue?vue&type=script&lang=js&"
export * from "./wxprice.vue?vue&type=script&lang=js&"
import style0 from "./wxprice.vue?vue&type=style&index=0&id=87da6980&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87da6980",
  null
  
)

export default component.exports